// DPO owns button cloning, availability and validation. Only gate its visibility.
if (!customElements.get('tweed-dpo-cart-gate')) {
  customElements.define('tweed-dpo-cart-gate', class extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.wrapper = this.closest('[data-dpo-cart-state]');
      if (!this.form || !this.wrapper) return;

      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      };
      this.guardSubmit = (event) => {
        if (this.update()) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      };
      this.containers = new Set();
      this.resizeObserver = new ResizeObserver(this.schedule);
      this.mutationObserver = new MutationObserver(this.schedule);
      this.mutationObserver.observe(this.form, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['class', 'style', 'hidden'],
      });
      this.form.addEventListener('submit', this.guardSubmit, true);
      this.form.addEventListener('transitionend', this.schedule);
      window.addEventListener('resize', this.schedule);
      window.addEventListener('load', this.schedule);
      this.update();
    }

    isDisplayed(container) {
      const rect = container.getBoundingClientRect();
      if (!rect.width || !rect.height) return false;
      // This is rendered visibility, independent of the customer's scroll position.
      for (let element = container; element; element = element.parentElement) {
        const style = getComputedStyle(element);
        if (style.display === 'none' || style.visibility === 'hidden'
          || style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
      }
      return true;
    }

    update() {
      const containers = new Set(this.form.querySelectorAll('.dpo-container'));
      for (const container of this.containers) {
        if (!containers.has(container)) this.resizeObserver.unobserve(container);
      }
      for (const container of containers) {
        if (!this.containers.has(container)) this.resizeObserver.observe(container);
      }
      this.containers = containers;
      const ready = [...containers].some((container) => this.isDisplayed(container));
      this.wrapper.dataset.dpoCartState = ready ? 'ready' : 'loading';
      return ready;
    }

    disconnectedCallback() {
      this.mutationObserver?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.form?.removeEventListener('submit', this.guardSubmit, true);
      this.form?.removeEventListener('transitionend', this.schedule);
      window.removeEventListener('resize', this.schedule);
      window.removeEventListener('load', this.schedule);
    }
  });
}
